module.exports = __webpack_public_path__ + "img/7_170.dda236b3.png";